<template>
  <svg
    height="40"
    width="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34.1548 35.3561L23.0158 32.0713L31.43 24.0671L34.1548 35.3561Z"
      fill="url(#logo_gradient_a)"
    />
    <path
      d="M17.2148 0C26.7226 0 34.4306 7.7072 34.4307 17.2148C34.4307 26.7225 26.7226 34.4297 17.2148 34.4297C7.70731 34.4295 0 26.7224 0 17.2148C1.415e-05 7.70734 7.70732 0.000221635 17.2148 0ZM11.1143 9.24512V25.1914H24.3428L16.4297 17.2783H20.6279C22.8464 17.2783 24.6445 15.4802 24.6445 13.2617C24.6444 11.0434 22.8463 9.24512 20.6279 9.24512H11.1143Z"
      fill="url(#logo_gradient_b)"
    />
    <defs>
      <linearGradient id="logo_gradient_a" x1="19.8907" y1="30.3967" x2="32.6505" y2="30.885" gradientUnits="userSpaceOnUse">
        <stop stop-color="#8932F7"/>
        <stop offset="1" stop-color="#D688CD"/>
      </linearGradient>
      <linearGradient id="logo_gradient_b" x1="34.9743" y1="34.4678" x2="12.1019" y2="10.9787" gradientUnits="userSpaceOnUse">
        <stop stop-color="#8932F7"/>
        <stop offset="1" stop-color="#D688CD"/>
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>